import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  rtl: true,
  theme: {
    themes: {
      light: {
        primary: "#af0655",
        secondary: "#b0bec5",
        accent: "#f00271",
        error: "#b71c1c",
        sidebar: "#292f3b",
        dashboardMain: "#202020",
        dashboardSecondary: "#313745",
        logoColor: "#991953",
      },
    },
  },
});
